module.exports = __webpack_public_path__ + "static/media/Communications.744c4ede.svg";